export default "__VITE_ASSET__BLXIAt3A__"